// @flow
import * as React from 'react'

type AlignItemsValue = 'center' | 'flex-end'
type JustifyContentValue = 'space-between'
type Gutters = 'wide' | 'skinny'

type Props = {
  alignItems?: AlignItemsValue,
  column: boolean,
  full: boolean,
  gutters?: Gutters,
  justifyContent?: JustifyContentValue,
  wrap: boolean,
  children: React.Node,
}

export default class Grid extends React.Component<Props> {
  static defaultProps = {
    column: false,
    full: false,
    wrap: true,
  }

  render = () => {
    return <div className={`Grid ${this.classNameModifer}`}>{this.props.children}</div>
  }

  get classNameModifer(): string {
    return [
      this.alignItemsClassNameModifer,
      this.guttersClassNameModifier,
      this.justifyContentClassNameModifer,
      this.props.column ? 'Grid--column' : '',
      this.props.full ? 'Grid--full' : '',
      this.props.wrap ? '' : 'Grid--noWrap',
    ].join(' ')
  }

  get alignItemsClassNameModifer(): string {
    switch (this.props.alignItems) {
      case 'center':
        return 'Grid--alignItemsCenter'

      case 'flex-end':
        return 'Grid--alignItemsFlexEnd'

      default:
        return ''
    }
  }

  get guttersClassNameModifier(): string {
    switch (this.props.gutters) {
      case 'wide':
        return 'Grid--wideGutters'

      case 'skinny':
        return 'Grid--skinnyGutters'

      default:
        return ''
    }
  }

  get justifyContentClassNameModifer(): string {
    switch (this.props.justifyContent) {
      case 'space-between':
        return 'Grid--justifyContentSpaceBetween'

      default:
        return ''
    }
  }
}
